import React, { useState, useEffect, useRef } from 'react';


import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation, redirect } from 'react-router-dom';
import i18n from './i18n';

import {
  Dropdown, DropdownToggle, DropdownMenu, DropdownItem,
  Button, Container, Row, Col,
  // Card, CardBody, CardTitle, CardSubtitle, CardText 
} from 'reactstrap';

// css style can be found in Navigation.css file

// export default function LanguageSwitcher() {
const LanguageSwitcher = () => {
  const isMountedRef = useRef();
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const [curLang, setCurLang] = useState(i18n.language);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  let curLangUI = i18n.language;

  const changeLanguage = (lngTar) => {

    setCurLang(i18n.language)
    i18n.changeLanguage(lngTar);

    let langCurrent = 'en-HK';
    if(lngTar == 'en-HK'){
      langCurrent = 'zh-HK';
    }
    window.localStorage.setItem("i18nextLng", lngTar);

    const newPath = window.location.pathname.replace(`/${langCurrent}`, `/${lngTar}`);
    navigate(newPath);

    // console.log('LanguageSwitcher changeLanguage newPath = ')
    // console.log(newPath)

  };

    useEffect(() => {
  
      curLangUI = curLang;
  
    }, [curLang]);

    useEffect(() => {
  
      isMountedRef.current = true;
  
      return () => {
        isMountedRef.current = false;
        // console.log("LanguageSwitcher unmount")
  
      };
    }, []);
  

  const displayLabel = curLangUI === 'zh-HK' ? '中文' : 'ENGLISH';

  return (
    <Dropdown isOpen={dropdownOpen} toggle={() => setDropdownOpen(!dropdownOpen)}>
      <DropdownToggle className='nav-lang-toggle' tag='button'>
        {displayLabel}
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 16 16" style={{ marginLeft: 6 }}>
          <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
        </svg>
      </DropdownToggle>
      <DropdownMenu end className='nav-lang-menu'>
        <DropdownItem className='nav-lang-item' onClick={() => changeLanguage('zh-HK')}>中文</DropdownItem>
        <DropdownItem className='nav-lang-item' onClick={() => changeLanguage('en-HK')}>ENGLISH</DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
}

export default LanguageSwitcher;